export default __webpack_public_path__ + "static/media/voucher.cc63444a.png";